module.exports = __webpack_public_path__ + "static/c2-ffe0db0043bd85059b0d17f7a7e04a74.jpg";